export default "__VITE_ASSET__DpMkcxJs__"